/* eslint-disable no-unused-vars */
import { AuthMultipleOnBehalfOfError } from './errors';
export function generateOnBehalfOfScope(id, type = 'cm_id') {
    if (!id) {
        return '';
    }
    return `on_behalf_of:${type}:${id}`;
}
/**
 *
 * @param {RegExpStringIterator<RegExpExecArray>} [regexResults] - RegExp iterator
 *
 * @returns {string} `ResourceOwner` or `null`
 */
function extractResource(regexResults) {
    const match = regexResults.next();
    // No match
    if (match.done) {
        return null;
    }
    // More than one match
    if (!regexResults.next().done) {
        throw new AuthMultipleOnBehalfOfError();
    }
    // type and id should be the last two elements
    const type = match.value[match.value.length - 2];
    const id = match.value[match.value.length - 1];
    if (!type || !id) {
        return null;
    }
    return `${type}:${id}`;
}
export function extractResourceOwnerFromScope(scope) {
    if (!scope) {
        return null;
    }
    const regexResults = scope.matchAll(/on_behalf_of:(\w+):(\w+)/g);
    return extractResource(regexResults);
}
/**
 *
 * @param {AuthIdTokenParsed['on_behalf_of']} [onBehalfOf] - OAuth2 on_behalf_of claim
 *
 * @returns {string} `ResourceOwner` or `null`
 */
export function extractResourceOwnerFromTokenOnBehalfOf(onBehalfOf) {
    if (!(onBehalfOf === null || onBehalfOf === void 0 ? void 0 : onBehalfOf.resource_owner)) {
        return null;
    }
    const regexResults = onBehalfOf.resource_owner.matchAll(/(\w+:)?(\w+):(\w+)/g);
    return extractResource(regexResults);
}
